 <template>

   <!--关注公众号弹窗-->
   <div class="alert-focus">
     <div class="mask"></div>
     <div class="focus-con">
       <img class="focus-tit" src="../assets/focus-tit.png" alt="">
       <div class="focus-line"></div>
       <img class="focus-img" v-show="focusRes.isconfig==5" src="../assets/focus-img.png" alt="">
       <img class="focus-img" v-show="focusRes.isconfig==6" :src="focusRes.qrcode" alt="">
       <div class="focus-text tc">长按<span>识别关注</span>{{focusRes.isconfig==6?'公众号':'金牌解说'}}</div>
       <img class="focus-close"  v-on:click="closeFun()" src="../assets/focus-close.png" alt="">
     </div>
   </div>

</template>

 <script>
   import {setStore, getStore, removeStore} from '@/config/mUtils'
   import D from '@/wc-messagebox'
   import Vue from 'vue'
   Vue.use(D)

   export default {
     data(){
       return{

       }
     },
     created(){},
     props: ['focusRes'],
     computed: {

     },
     methods: {
       closeFun(){
         this.$emit('alert-Focus',0);
       }
     },
   }
 </script>

 <style scoped>
   /*公众号关注弹窗*/
   .alert-focus{position: fixed;z-index:10;left:0;top:0;width: 100%;height: 100%;}
   .alert-focus .mask{position: absolute;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.52);}
   .focus-con{position:absolute;top:45%;left:50%;width: 85%;padding-bottom:.72rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);border-radius: .16rem;background: #fff;}
   .focus-tit{display: block;width: 2.42rem;height: auto;margin: -.04rem auto 0;}
   .focus-line{display: block;width: 83.85%;height: 1px;border-bottom: 1px dashed #e5e5e5;margin: .33rem auto 0;}
   .focus-img{display: block;width:2.77rem;height:auto;margin: .52rem auto 0;}
   .focus-close{position:absolute;left:50%;bottom:-.96rem;width: .53rem;height: auto;margin-left: -.265rem;}
   .focus-text{margin-top: .45rem;font-size: .32rem;color: #ffa102;}
   .focus-text span{color: #909090;}
 </style>



// WEBPACK FOOTER //
// src/components/Focus.vue